export * from 'proxy-target/traps';
export const DESTRUCT = 'destruct';
export const VALUE_OF = 'valueOf';
